import React, { useState } from 'react';
import {
    Table, Button, Space, Typography, Divider, message, Modal, Form,
    Input, Select, Tag, Breadcrumb, Tabs
} from 'antd';
import { PlusOutlined, EyeOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// TODO: 联调时替换为接口数据
const MOCK_SEGMENTS_MALL = [
    { id: 1, name: '商城高消费用户', code: 'ug_mall_high_spend', count: 8320, bound: true },
    { id: 2, name: '商城新注册用户', code: 'ug_mall_new_reg', count: 15640, bound: false },
    { id: 3, name: '商城沉默用户', code: 'ug_mall_silent', count: 6180, bound: false },
];

const MOCK_SEGMENTS_REC = [
    { id: 4, name: '高价值推荐用户', code: 'ug_rec_high_value', count: 12580, bound: true },
    { id: 5, name: '活跃推荐用户', code: 'ug_rec_active', count: 45230, bound: false },
];

const MOCK_SEGMENTS_AD = [
    { id: 6, name: '广告高转化用户', code: 'ug_ad_high_conv', count: 9870, bound: true },
    { id: 7, name: '广告新用户', code: 'ug_ad_new_user', count: 22410, bound: false },
    { id: 8, name: '广告沉默用户', code: 'ug_ad_silent', count: 5340, bound: false },
];

const MOCK_BOUND_STRATEGIES = {
    ug_rec_high_value: [
        { app: '牵心PRO', appId: 'QX_PRO_001', slot: '首页推荐位', slotCode: 'rec_slot_home', strategy: '首页推广策略', conditions: '条件一：未购买云存储 → 首页基础漏斗\n条件二：3≤循环时长<7 → 升级推荐漏斗' },
        { app: '牵心PRO', appId: 'QX_PRO_001', slot: '活动推荐位', slotCode: 'rec_slot_activity', strategy: '活动推荐策略', conditions: '条件一：未购买云存储 → 活动基础漏斗' },
        { app: '鹤梦之家', appId: 'HM_HOME_001', slot: '首页推荐位', slotCode: 'rec_slot_home', strategy: '首页基础策略', conditions: '条件一：未购买云存储 → 首页基础漏斗' },
    ],
    ug_mall_high_spend: [
        { app: '牵心PRO', appId: 'QX_PRO_001', strategy: '高价值用户专属' },
        { app: '鹤梦之家', appId: 'HM_HOME_001', strategy: '商城推广策略' },
    ],
    ug_ad_high_conv: [
        { app: '牵心PRO', appId: 'QX_PRO_001', strategy: '广告推广策略', adSlots: '开屏广告位、插屏广告位', global: '开屏/插屏冷却间隔 30s' },
        { app: '鹤梦之家', appId: 'HM_HOME_001', strategy: '广告基础策略', adSlots: '开屏广告位', global: '开屏/插屏冷却间隔 60s' },
    ],
};

const UserSegment = () => {
    const [mallSegments, setMallSegments] = useState(MOCK_SEGMENTS_MALL);
    const [recSegments, setRecSegments] = useState(MOCK_SEGMENTS_REC);
    const [adSegments, setAdSegments] = useState(MOCK_SEGMENTS_AD);
    const [createModal, setCreateModal] = useState({ open: false, type: 'mall' });
    const [createForm] = Form.useForm();
    const [viewModal, setViewModal] = useState({ open: false, code: null });

    const handleCreate = async () => {
        const values = await createForm.validateFields();
        const newSegment = { id: Date.now(), name: values.name, code: values.code, count: 0, bound: false };
        if (createModal.type === 'mall') setMallSegments(prev => [...prev, newSegment]);
        else if (createModal.type === 'rec') setRecSegments(prev => [...prev, newSegment]);
        else setAdSegments(prev => [...prev, newSegment]);
        setCreateModal({ open: false, type: 'mall' });
        createForm.resetFields();
        message.success('分群已创建');
    };

    const boundStrategies = viewModal.code ? (MOCK_BOUND_STRATEGIES[viewModal.code] || []) : [];

    const renderTable = (data, type) => (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                <Text strong style={{ fontSize: 14 }}>{type}用户分群列表</Text>
                {type === '广告' && <Button type="primary" icon={<PlusOutlined />} onClick={() => { setCreateModal({ open: true, type: 'ad' }); createForm.resetFields(); }}>创建分群</Button>}
            </div>
            <Table
                dataSource={data} rowKey="id" size="small"
                columns={[
                    { title: '序号', render: (_, __, i) => i + 1, width: 60 },
                    { title: '分群名称', dataIndex: 'name' },
                    { title: '分群编码', dataIndex: 'code', render: v => <Text code>{v}</Text> },
                    { title: '用户数量', dataIndex: 'count', render: v => v.toLocaleString() },
                    {
                        title: '绑定策略', key: 'bound',
                        render: (_, r) => r.bound ? (
                            <Space><Tag color="blue">已绑定</Tag><Button type="link" size="small" icon={<EyeOutlined />} onClick={() => setViewModal({ open: true, code: r.code })}>查看</Button></Space>
                        ) : <Tag>未绑定</Tag>,
                    },
                ]}
            />
        </div>
    );

    return (
        <div style={{ padding: '24px', backgroundColor: '#fff', minHeight: '100vh' }}>
            <Breadcrumb style={{ marginBottom: 16 }} items={[{ title: '运营管理' }, { title: '用户分群' }]} />
            <Title level={4} style={{ marginBottom: 24 }}>用户分群</Title>

            <Tabs defaultActiveKey="mall" items={[
                { key: 'mall', label: '商城用户分群', children: renderTable(mallSegments, '商城') },
                { key: 'rec', label: '推荐用户分群', children: renderTable(recSegments, '推荐') },
                { key: 'ad', label: '广告用户分群', children: renderTable(adSegments, '广告') },
            ]} />

            {/* 创建分群 Modal */}
            <Modal title="创建分群" open={createModal.open} onCancel={() => setCreateModal({ open: false, type: 'mall' })} onOk={handleCreate} okText="确定" cancelText="取消" width={520}>
                <Form form={createForm} layout="vertical">
                    <Form.Item label="分群名称" name="name" rules={[{ required: true }]}><Input placeholder="请输入分群名称" /></Form.Item>
                    <Form.Item label="分群编码" name="code" rules={[{ required: true }]} extra="建议使用英文+下划线格式"><Input placeholder="如 ug_mall_xxx" /></Form.Item>
                    <Form.Item label="分群描述" name="desc"><Input.TextArea rows={3} placeholder="请输入分群描述" /></Form.Item>
                    <Form.Item label="分群规则" name="rule">
                        <Select placeholder="请选择分群规则" options={[
                            { value: 'amount', label: '按消费金额' }, { value: 'reg_time', label: '按注册时间' },
                            { value: 'active', label: '按活跃度' }, { value: 'device', label: '按设备数量' },
                            { value: 'custom', label: '自定义规则' },
                        ]} />
                    </Form.Item>
                </Form>
            </Modal>

            {/* 查看绑定策略 Modal */}
            <Modal
                title={<span>当前分群：{MOCK_SEGMENTS_REC.find(s => s.code === viewModal.code)?.name || MOCK_SEGMENTS_MALL.find(s => s.code === viewModal.code)?.name || MOCK_SEGMENTS_AD.find(s => s.code === viewModal.code)?.name || ''}（{viewModal.code}）</span>}
                open={viewModal.open}
                onCancel={() => setViewModal({ open: false, code: null })}
                footer={<Button onClick={() => setViewModal({ open: false, code: null })}>关闭</Button>}
                width={700}
            >
                {boundStrategies.map((item, i) => (
                    <div key={i} style={{ marginBottom: 16, padding: 12, background: '#fafafa', borderRadius: 8 }}>
                        <div style={{ marginBottom: 4 }}>
                            <Text strong>{item.app}</Text> <Text type="secondary">{item.appId}</Text>
                        </div>
                        {item.slot && <div style={{ fontSize: 13, marginBottom: 4 }}>推荐位：{item.slot}（{item.slotCode}）</div>}
                        <div style={{ fontSize: 13, marginBottom: 4 }}>策略名称：{item.strategy}</div>
                        {item.adSlots && <div style={{ fontSize: 13, marginBottom: 4 }}>包含广告位：{item.adSlots}</div>}
                        {item.global && <div style={{ fontSize: 13, marginBottom: 4 }}>全局策略：{item.global}</div>}
                        {item.conditions && <div style={{ fontSize: 12, color: '#666', whiteSpace: 'pre-line' }}>条件漏斗：{item.conditions}</div>}
                        {i < boundStrategies.length - 1 && <Divider style={{ margin: '12px 0' }} />}
                    </div>
                ))}
                {boundStrategies.length === 0 && <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无绑定策略</div>}
            </Modal>
        </div>
    );
};

export default UserSegment;
